// ============================================================
// cf-filter.js � Advanced Filter Modal + Active Filter Bar
// Load hanya pada halaman yang menggunakan filter modal.
//
// Dependencies: site.js
//
// Customization:
//   Definisikan window.FILTER_LABEL_MAP di page script SEBELUM
//   memanggil updateFilterUI() untuk override label per halaman.
//
//   Contoh di page script:
//     window.FILTER_LABEL_MAP = {
//         status:   'Status',
//         role:     'Role',
//         dateFrom: 'Tanggal Mulai'
//     };
// ============================================================

(function () {
    'use strict';

    // ????????????????????????????????????????????????????????
    // Advanced Filter Modal
    // ????????????????????????????????????????????????????????
    window.openFilterModal = function () {
        if (typeof activeFilters !== 'undefined') {
            Object.keys(activeFilters).forEach(function (key) {
                var el = document.getElementById('f-' + key);
                if (el) el.value = activeFilters[key] || '';
            });
        }
        var overlay = document.getElementById('modal-overlay');
        if (overlay) overlay.classList.add('show');
    };

    window.closeFilterModal = function () {
        var overlay = document.getElementById('modal-overlay');
        if (overlay) overlay.classList.remove('show');
    };

    window.onOverlayClick = function (e) {
        if (e.target === e.currentTarget) closeFilterModal();
    };

    // ????????????????????????????????????????????????????????
    // Active Filter Bar (chips)
    // Default label map � di-override per page via window.FILTER_LABEL_MAP
    // ????????????????????????????????????????????????????????
    var _defaultLabelMap = {
        status:     'Status',
        role:       'Role',
        department: 'Department',
        keyword:    'Keyword',
        dateFrom:   'Date from',
        dateTo:     'Date to',
        level:      'Level',
        type:       'Type',
        kw:         'Keyword'
    };

    function _getLabelMap() {
        return (typeof window.FILTER_LABEL_MAP === 'object' && window.FILTER_LABEL_MAP !== null)
            ? window.FILTER_LABEL_MAP
            : _defaultLabelMap;
    }

    function _getLabel(key) {
        var map = _getLabelMap();
        return map[key] || key;
    }

    window.updateFilterUI = function (activeFilters, onRemoveCallback) {
        var keys  = Object.keys(activeFilters);
        var badge = document.getElementById('filter-badge');
        var bar   = document.getElementById('filter-bar');

        var count = keys.filter(function (k) { return activeFilters[k]; }).length;
        if (badge) {
            badge.textContent = count;
            badge.classList.toggle('show', count > 0);
        }
        if (!bar) return;

        if (count === 0) {
            bar.classList.remove('show');
            bar.innerHTML = '';
            return;
        }

        var html = '';
        keys.forEach(function (key) {
            if (!activeFilters[key]) return;
            html += '<span class="filter-chip">' +
                '<span>' + _getLabel(key) + ': ' + activeFilters[key] + '</span>' +
                '<button class="filter-chip-remove" onclick="' + onRemoveCallback + '(\'' + key + '\')">' +
                    '<i class="fa-solid fa-xmark"></i>' +
                '</button>' +
            '</span>';
        });
        html += '<button class="filter-clear-all" onclick="' + onRemoveCallback + '(\'__all__\')">Clear all</button>';

        bar.innerHTML = html;
        bar.classList.add('show');
    };

})();
